import {ProcessedHotel, ProcessedOtherContent, ProcessedTourCatalog, ProcessedTourOperator} from "./contentfulModel.ts";
import React, {act, useEffect, useRef, useState} from "react";
import classNames from "classnames";
import {Navigation, Pagination} from "swiper/modules";
import {Swiper, SwiperSlide} from "swiper/react";

interface TourCatalogAdditionalContentProps {
    tourOperator: ProcessedTourOperator;
    tourCatalog: ProcessedTourCatalog;
    hotels: ProcessedHotel[];
    goToSlide: (slideIndex: number) => void;
}

// Arrow left icon component
const ArrowLeftIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
        <path fillRule="evenodd" d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8z"/>
    </svg>
);

// Arrow right icon component
const ArrowRightIcon = () => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd"
              d="M19.8848 10.0001C19.8848 10.7344 19.3284 11.3296 18.642 11.3296L1.24315 11.3296C0.55678 11.3296 0.000371985 10.7344 0.000372049 10.0001C0.000372113 9.26586 0.55678 8.67063 1.24315 8.67063L18.642 8.67063C19.3284 8.67063 19.8848 9.26586 19.8848 10.0001Z"
              fill="currentColor"/>
        <path fill-rule="evenodd" clip-rule="evenodd"
              d="M9.25952 19.6339C8.78297 19.1457 8.78297 18.3543 9.25952 17.8661L16.9387 10L9.25952 2.13388C8.78297 1.64573 8.78297 0.854272 9.25952 0.366118C9.73608 -0.122039 10.5087 -0.122039 10.9853 0.366119L19.5274 9.11612C20.0039 9.60427 20.0039 10.3957 19.5274 10.8839L10.9853 19.6339C10.5087 20.122 9.73608 20.122 9.25952 19.6339Z"
              fill="currentColor"/>
    </svg>

);
export const TourCatalogAdditionalContentHotels = ({  tourOperator ,hotels,tourCatalog, goToSlide}: TourCatalogAdditionalContentProps) => {


    const [activeCategory, setActiveCategory] = useState<string | null>(null);
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
    const [categories, setCategories] = useState([]);
    const [categoryGroups, setCategoryGroups] = useState([]);
    const [activeCategoryGroup, setActiveCategoryGroup] = useState<string[]>([]);
    const navContainerRef = useRef<HTMLDivElement>(null);



    useEffect(() => {
        //groups hotel by city
        const groupedHotels = hotels.reduce((acc, hotel) => {
            const city = hotel.location?.toLowerCase() || hotel.city?.toLowerCase();
            if (!acc[city]) {
                acc[city] = [];
            }
            acc[city].push(hotel);
            return acc;
        }, {});

        //create a list of categories with name and hotels
        setCategories(Object.keys(groupedHotels).map(city => ({
            name: city.toLowerCase(),
            hotels: groupedHotels[city]
        })))


    }, []);

    // Function to handle going back to index
    const handleBackToIndex = () => {
        if(activeCategory) {
            setActiveCategory(null);
        } else {
            goToSlide(1);
        }
    };

    const operatorColor = tourOperator?.primaryColor || '#3B82F6';


    // Function to handle category click
    const handleCategoryClick = (category: any) => {

        let groups = []
        category.hotels.forEach(
            (hotel) => {

                groups.push(hotel.group)
            }
        )
        const catArray = Array.from(new Set(groups))
        setActiveCategory(activeCategory === category ? null : category);
        setCategoryGroups(catArray);
        setActiveCategoryGroup(catArray.sort(
            (a, b) => a.localeCompare(b)
        )[0])
    };


    return (<div className="flex flex-col md:flex-row w-full h-full flex-col-reverse overflow-y-scroll">
        {/* Left Section - 65% width */}
        <div className={`w-full md:px-[70px] md:overflow-y-scroll transition-all duration-300 ease-in-out ${
            activeCategory ? 'md:w-[100%]' : 'md:w-[50%]'
        } p-8 h-full text-left md:pt-6`}>
            <div>
            {/* Back to index button - shown only when a category is active */}
            {activeCategory ? (
                <div>
                <div
                    onClick={handleBackToIndex}
                    className="bg-white md:bg-white ml-0 p-3 md:pl-4 rounded-xl absolute md:relative cursor-pointer bg-transparent flex items-center gap-2 text-black hover:underline top-3 md:top-auto md:mb-6 opacity-85 left-4 md:left-auto w-auto self-start md:max-w-60"
                    style={{
                        boxShadow: isMobile ? "0px 4px 4px 0px #00000040" : ""
                    }}
                >
                    <ArrowLeftIcon/>
                    <span className="text-sm font-semibold">Volver a Hoteles</span>
                </div>
                    <div className="fixed bottom-0 md:top-5 left-2 md:left-auto md:right-[40px] z-20 rounded-md overflow-hidden">
                        <div
                            ref={navContainerRef}
                            className="overflow-x-auto hide-scrollbar py-3"
                            style={{ maxWidth: '100vw', WebkitOverflowScrolling: 'touch',
                                backdropFilter: 'blur(14.100000381469727px)'
                            }}
                        >
                        <ul className="flex flex-row nowrap gap-1 p-0 h-[45px] rounded-lg">
                            {categoryGroups.length > 1 && categoryGroups.sort(
                                (a, b) => a.localeCompare(b)
                            ).map((group, index) => {
                                const cleanGroup = typeof group === 'string' ? group.replace(/\.0$/, '') : group;
                                const isFirst = index === 0;
                                const isLast = index === categoryGroups.length - 1;
                                const isActive = activeCategoryGroup === group;

                                const baseClasses = `flex-shrink-0 flex items-center h-[45px] px-4 py-2 cursor-pointer text-sm`;
                                const activeClasses = isActive ? 'text-white font-bold' : 'bg-white text-[#AFAFAF] hover:bg-gray-100';
                                const roundedClasses = `${isFirst ? 'rounded-l-lg' : ''} ${isLast ? 'rounded-r-lg' : ''}`;

                                return (
                                    <li
                                        key={group}
                                        className={`${baseClasses} ${activeClasses} ${roundedClasses}`}
                                        style={{ backgroundColor: isActive ? operatorColor : '' }}
                                        onClick={() => setActiveCategoryGroup(group)}
                                    >
                                        {cleanGroup}
                                    </li>
                                );
                            })}


                        </ul>
                    </div>
                </div>
                </div>
                ) : <div className="mb-4 md:mb-6">
                <div
                onClick={handleBackToIndex}
            className="bg-white md:bg-white ml-0 p-3 rounded-xl absolute top-[20px] md:relative cursor-pointer bg-transparent flex items-center gap-2 text-black hover:underline top-3 md:top-auto md:mb-6 opacity-85 left-4 md:left-auto w-auto self-start md:max-w-60"
            style={{
                boxShadow: isMobile ? "0px 4px 4px 0px #00000040" : ""
            }}
        >
            <ArrowLeftIcon/>
            <span className="text-sm font-semibold">Volver al índice</span>
        </div>
                <h3 className="text-sm font-normal uppercase text-gray-600 mb-2">
                    Hoteles
                </h3>
                <h2 className="text-2xl md:text-3xl font-bold">
                    Descubre el hotel de tu viaje
                </h2>
            </div>}
            {/* Tour Package Information */}
            <div className="mb-6 md:pt-0 md:overflow-y-scroll">
                <h2 className="text-xl md:text-2xl font-semibold md:font-semibold mb-1">
                    {activeCategory ? activeCategory.name.toUpperCase() : ""}
                </h2>
                {/* Main Index Categories */}
                <div id="parentIndx" className="mt-4 md:mt-0 md:overflow-y-scroll">
                    <ul className="space-y-4 pl-0">
                        {categories.sort(
                            (a, b) => a.name.localeCompare(b.name)
                        ).map((category, idx) => (
                            (activeCategory === null || activeCategory === category.name) && (
                                <li key={idx}
                                    className={classNames([
                                        "cursor-pointer text-lg md:text-xl font-medium cursor-pointer flex justify-between items-center pb-3",
                                        !activeCategory ? "border-b-1" : ""
                                    ])}
                                    style={{
                                    }}
                                    onClick={() => handleCategoryClick(category)}
                                >
                                    <span className="uppercase">{category.name}</span>
                                    {!activeCategory ?
                                        <span style={{color: operatorColor}}>
                                        <ArrowRightIcon/>
                                    </span> : null}
                                </li>
                            )
                        ))}
                    </ul>

                    {/* Tour packages with image, name and subtitle */}
                    {activeCategory && (
                        <div className="mt-0 space-y-6 md:overflow-y-scroll">
                            {
                                activeCategory.hotels.filter(
                                    (hotel) => hotel.group === activeCategoryGroup
                                ).sort(
                                    (a, b) => a.name - b.name
                                ).map((hotel, index) => (
                                    <div
                                        key={hotel.name+activeCategoryGroup+index}
                                        className="group"

                                    >
                                        {/* Gray separator */}
                                        <div className="h-px bg-gray-200 mb-4 w-full "></div>

                                        <div className="flex gap-4 items-center flex-col md:flex-row">

                                            <div className="flex-grow h-full w-full md:w-[50%]">
                                                <Swiper
                                                    modules={[Navigation,Pagination]}
                                                    pagination={{
                                                        clickable: true,
                                                        dynamicBullets: true,
                                                    }}
                                                    style={{
                                                        '--swiper-pagination-color': "#FFF",
                                                        '--swiper-pagination-bullet-inactive-color': '#999999',
                                                    }}

                                                    spaceBetween={0}
                                                    slidesPerView={1}
                                                    centeredSlides={true}
                                                    className="h-full w-full"
                                                >
                                                    {
                                                        hotel.images.map((image, index) => (
                                                            <SwiperSlide key={"Slide"+index} className="w-full h-full">
                                                            <div key={index} className="w-full h-full rounded-xl">
                                                                <img crossOrigin="anonymous"
                                                                     src={image.file}
                                                                     alt={image.file.name}
                                                                     className="w-full h-full object-cover rounded-xl max-h-[265px] md:max-h-[330px] max-w-[600px]"
                                                                />
                                                            </div></SwiperSlide>
                                                        ))
                                                    }
                                               </Swiper>
                                                </div>

                                            {/* Tour package name and subtitle */}
                                            <div className="md:w-[50%]">
                                                <h4 className="text-md md:text-lg uppercase mb-1">{hotel.name}</h4>
                                                {hotel.description && (
                                                    <p className="text-sm text-gray-600">{hotel.description}</p>
                                                )}

                                            </div>

                                        </div>
                                    </div>
                                ))
                            }
                        </div>
                    )}
                </div>

                <div className="mt-4 md:mt-8">
                </div>
            </div>
            </div>
            { tourCatalog.partnerLogo ?
                <div>
                    <img src={tourCatalog.partnerLogo.file} alt="Partner Logo" className="w-30 md:w-40 md:mt-10  md:block"/>
                </div> : null }
        </div>

        {/* Right Section - 35% width */}
        <div className={`w-full transition-all duration-300 ease-in-out ${
            activeCategory ? 'md:w-[0%]' : 'md:w-[70%]'
        } h-[140px] md:h-full flex flex-col`}>
            <div className="h-full">
                <img crossOrigin="anonymous"
                    src={tourCatalog.hotelsImage?.file}
                    className="w-full h-full object-cover rounded-b-2xl md:rounded-r-none md:rounded-l-2xl"
                /><img crossOrigin="anonymous"
                       src={tourOperator.logoContrast.file}
                       className="w-40 md:absolute bottom-4 right-4 hidden md:block"
                       alt={tourOperator.name}/>
            </div>
        </div>
    </div>)
}
